import { render } from "./long-insure-dispatch.vue?vue&type=template&id=5a31b6a0&scoped=true&ts=true"
import script from "./long-insure-dispatch.vue?vue&type=script&lang=ts"
export * from "./long-insure-dispatch.vue?vue&type=script&lang=ts"

import "./long-insure-dispatch.vue?vue&type=style&index=0&id=5a31b6a0&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a31b6a0"]])

export default __exports__